import { Pipe, PipeTransform } from '@angular/core';
import { InsuranceType } from '@src/app/features/web-submission/enums/insurance-type.enum';

@Pipe({
  name: 'insuranceTypePipe',
})
export class InsuranceTypePipe implements PipeTransform {
  transform(value: InsuranceType): string {
    switch (value) {
      case InsuranceType.CAR:
        return 'Auto Insurance';
      case InsuranceType.AUTO_LIFE:
        return 'Auto Life';
      default:
        return value;
    }
  }
}
